import * as angular from 'angular';
import { relativeTimeThreshold } from 'moment';

import { ComponentDefinition } from '../../../models';

class DuplicateGenericModalController implements angular.IComponentController {
    formCtrl: angular.IFormController;
    newName: string;
    title: string;

    readonly existingNames: string[];
    readonly modalId: string;
    readonly name: string;
    readonly onCancel: () => void;
    readonly onDuplicate: ({ name: string }) => void;
    readonly type: string;

    static $inject = [];

    $onInit() {
        this.newName = this.name;
        this.setNameValidationState(this.newName);
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['name']?.currentValue) {
            this.newName = this.name;
            this.setNameValidationState(this.newName);
        }
        if (changes['existingNames']?.currentValue) {
            if (this.newName) {
                this.setNameValidationState(this.newName);
            }
        }
    }

    onYes() {
        this.onDuplicate({ name: this.newName });
        $(`#${this.modalId}`).modal('hide');
        this.setPristine();
    }

    onNo() {
        this.setPristine();
        if (this.onCancel) {
            this.onCancel();
        }
        this.newName = this.name;
        this.setNameValidationState(this.newName);
    }

    private setPristine() {
        if (this.formCtrl) {
            this.formCtrl.$setPristine();
        }
    }

    validateName() {
        try {
            if (this.formCtrl.newName && this.existingNames) {
                this.setNameValidationState(this.formCtrl.newName.$viewValue);
            }
        }
        catch {
            // silent catch
            this.formCtrl?.newName?.$setValidity('duplicate', false);
        }
    }

    private setNameValidationState(name: string) {
        let isValid = false;
        if (this.formCtrl?.newName && this.existingNames) {
            name = name.toLowerCase();
            isValid = !this.existingNames.find(e => e.toLowerCase() === name);
            this.formCtrl?.newName?.$setValidity('duplicate', isValid);
        }
        return isValid;
    }

}

export const wtDuplicateGenericModal: ComponentDefinition = {
    componentId: 'wtDuplicateGenericModal',
    controller: DuplicateGenericModalController,
    template: require('./duplicateGenericModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        existingNames: '<',
        modalId: '@',
        name: '<',
        onCancel: '&?',
        onDuplicate: '&',
        type: '@',
    }
};